<template>
  <div class="fts-history-notification">
    <div class="history-notification-header">
      <div class="history-notification-header__l">
        <div class="history-notification-subject" v-if="data.subject">
          {{data.subject}}
        </div>
        <div class="history-notification-subject fts-text-default" v-else>
          (undefined)
        </div>
      </div>

      <div class="history-notification-status history-notification-status--error" v-if="data.status == 2">
        <i class="fts-icon-exclamation-triangle"></i>
      </div>
    </div>

    <div class="history-notification-target-container">
      <div class="history-notification-target-list" v-if="targets">
        <fts-history-notification-target
          v-for="x in targets"
          :key="x"
          :users="users"
          :target="x"
        />
        <div class="history-notification-target-more" v-if="targetsMore">
          +{{targetsMore.length}}
        </div>
      </div>

      <div class="history-notification-cc" v-if="data.cc && data.cc.length">
        CC
      </div>
      <div class="history-notification-cc" v-if="data.bcc && data.bcc.length">
        BCC
      </div>
    </div>

    <div class="history-notification-remark" v-if="data.remarks">
      {{data.remarks}}
    </div>

    <div class="history-notification-footer">
      <div>
        <span v-if="data.deliveredOn">
          {{moment(data.deliveredOn).format('lll')}}
        </span>
        <span v-if="channelText">
          via {{channelText}}
        </span>
      </div>
      <fts-tippy
        :options="{
          theme: 'light-border',
          interactive: true,
          placement: 'left-end'
        }"
        append-box-class="history-notification-details"
        class="history-notification-details-toggle"
      >
        <font-awesome-icon :icon="['fas', 'circle-info']" />
        <template #content>
          <div class="history-notification-header">
            <div class="history-notification-header__l">
              <div class="history-notification-subject" v-if="data.subject">
                {{data.subject}}
              </div>
              <div class="history-notification-subject fts-text-default" v-else>
                (undefined)
              </div>
            </div>

            <div class="history-notification-status history-notification-status--error" v-if="data.status == 2">
              <i class="fts-icon-exclamation-triangle"></i>
            </div>
          </div>

          <div class="history-notification-wrapper">
            <div class="history-notification-wrapper-label">To</div>
            <div class="history-notification-target-list">
              <fts-history-notification-target
                v-for="x in data.targets"
                :key="x"
                :users="users"
                :target="x"
              />
            </div>
          </div>

          <div class="history-notification-wrapper" v-if="data.cc && data.cc.length">
            <div class="history-notification-wrapper-label">CC</div>
            <div class="history-notification-target-list">
              <fts-history-notification-target
                v-for="x in data.cc"
                :key="x"
                :users="users"
                :target="x"
              />
            </div>
          </div>

          <div class="history-notification-wrapper" v-if="data.bcc && data.bcc.length">
            <div class="history-notification-wrapper-label">BCC</div>
            <div class="history-notification-target-list">
              <fts-history-notification-target
                v-for="x in data.bcc"
                :key="x"
                :users="users"
                :target="x"
              />
            </div>
          </div>

          <div class="history-notification-remark" v-if="data.remarks">
            {{data.remarks}}
          </div>

          <div class="history-notification-footer">
            <div>
              <span v-if="data.deliveredOn">
                {{moment(data.deliveredOn).format('lll')}}
              </span>
              <span v-if="channelText">
                via {{channelText}}
              </span>
            </div>
          </div>
        </template>
      </fts-tippy>
    </div>
  </div>
</template>

<script>
import moment from "moment";

import notification from '../../commons/notification';

import FTSHistoryNotificationTarget from './FTSHistoryNotificationTarget';
import FTSTippy from '../FTSTippy';

export default {
  props: {
    users: Array,
    data: Object,
  },
  components: {
    "fts-history-notification-target": FTSHistoryNotificationTarget,
    "fts-tippy": FTSTippy
  },
  methods: {
    moment
  },
  computed: {
    targets() {
      if (Array.isArray(this.data && this.data.targets))
        return this.data.targets.slice(0, 2);
    },
    targetsMore() {
      if (Array.isArray(this.data && this.data.targets) && this.data.targets.length > 2)
        return this.data.targets.slice(2);
    },
    channelText() {
      if (this.data.channel !== null && this.data.channel !== undefined) {
        return this.data.channel == 0 ? "App" : notification.channelText(this.data.channel);
      }
    }
  }
}
</script>

<style lang="scss">
@use "./src/assets/scss/vars" as *;

.fts-history-notification {
  margin-left: 0.25rem;
  margin-right: 0.25rem;
  padding: 0.625rem 0.5rem;
  border-radius: 0.5rem;
  font-size: 0.75rem;
  .history-notification-subject {
    @include text-overflow-ellipsis;
  }
  .history-notification-target-container {
    display: flex;
    align-items: center;
    margin-bottom: 0.375rem;
    .history-notification-target-list {
      flex: 1;
      flex-wrap: nowrap;
    }
  }
  .history-notification-target-more {
    line-height: 1.125rem;
  }
  .history-notification-cc {
    margin-left: 0.5rem;
    padding-left: 0.25rem;
    padding-right: 0.25rem;
    border-radius: 0.25rem;
    background-color: var(--fts-gray-200);
    line-height: 1.125rem;
    cursor: default;
    & + .history-notification-cc {
      margin-left: 0.25rem;
    }
  }
  .history-notification-details-toggle {
    visibility: hidden;
  }
  &:hover {
    background-color: var(--fts-gray-100);
    .history-notification-details-toggle {
      visibility: visible;
    }
  }
}

.fts-history-notification,
.history-notification-details {
  .history-notification-header {
    display: flex;
    align-items: flex-start;
    margin-bottom: 0.375rem;
    .history-notification-header__l {
      min-width: 0;
      flex: 1;
      line-height: 1rem;
    }
  }
  .history-notification-footer {
    display: flex;
    justify-content: space-between;
    color: var(--fts-default);
  }
  .history-notification-subject {
    font-weight: 500;
  }
  .history-notification-status {
    font-size: 0.875rem;
    line-height: 1rem;
    &.history-notification-status--error {
      color: var(--fts-danger);
    }
  }
  .history-notification-remark {
    margin-bottom: 0.375rem;
    font-size: 0.75rem;
    line-height: 1rem;
    color: var(--fts-default);
  }
  .history-notification-target-list {
    @include flex-gap($display: flex, $gapTop: 0.25rem, $gapLeft: 0.75rem);
    min-width: 0;
    font-size: 0.75rem;
    line-height: 1.125rem;
    .profile-badge {
      .profile-badge-name {
        font-size: 0.75rem;
      }
    }
  }
}

.history-notification-details {
  min-width: 350px;
  .history-notification-header,
  .history-notification-remark {
    margin-bottom: 0.75rem;
  }
  .history-notification-wrapper {
    display: flex;
    align-items: flex-start;
    margin-bottom: 1rem;
  }
  .history-notification-wrapper-label {
    width: 35px;
    line-height: 1.125rem;
    color: var(--fts-default);
  }
  .history-notification-target-list {
    flex: 1;
  }
}
</style>